import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { AuthContextType } from '../types/index';
import { User } from '../types/index';
import { MockTradingAPI } from '../services/mockAPI';



const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const token = sessionStorage.getItem('auth-token');
    const userData = sessionStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData) as User);
    }
    setLoading(false);
  }, []);

  const login = async (email: string, password: string): Promise<{ user: User; token: string }> => {
    const result = await MockTradingAPI.login(email, password);
    setUser(result.user);
    return result;
  };

  const signup = async (email: string, password: string, name: string): Promise<{ user: User; token: string }> => {
    const result = await MockTradingAPI.signup(email, password, name);
    setUser(result.user);
    return result;
  };

  const logout = (): void => {
    sessionStorage.removeItem('auth-token');
    sessionStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};